// extracted by mini-css-extract-plugin
export var marquee = "marquee-module--marquee--2IUZo";
export var transformer = "marquee-module--transformer--AT2sO";